<!-- <div><canvas width="100" height="100" id="canvas"></canvas></div> -->
<div class="grid grid-cols-2 grid-rows-2 gap-4 w-full h-full">
  <div class="border border-gray-400 p-4">
    <canvas id="canvasIA" class="w-full h-full"></canvas>
  </div>
  <div class="border border-gray-400 p-4">
    <canvas id="canvasTECYB" class="w-full h-full"></canvas>
  </div>
  <div class="border border-gray-400 p-4">
    <canvas id="canvasDL" class="w-full h-full"></canvas>
  </div>
  <div class="border border-gray-400 p-4">
    <canvas id="canvasEB" class="w-full h-full"></canvas>
  </div>
</div>
